import {Component, OnInit} from '@angular/core';
import {MatCard, MatCardContent} from "@angular/material/card";
import {DatePipe, NgIf} from "@angular/common";
import {ActivatedRoute, RouterOutlet} from "@angular/router";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {DialogService} from "../../../_modal/dialog.service";
import {MatExpansionPanelTitle} from "@angular/material/expansion";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: 'app-clients-rapport-details',
    providers: [ApiService, Endpoints, DialogService],
    standalone: true,
    imports: [
        MatCard,
        MatCardContent,
        NgIf,
        RouterOutlet,
        MatExpansionPanelTitle,
        DatePipe
    ],
    templateUrl: './clients-rapport-details.component.html',
    styleUrl: './clients-rapport-details.component.scss'
})
export class ClientsRapportDetailsComponent implements OnInit{
    clientId : string;
    sampleList : any[];

    constructor(
        private route: ActivatedRoute,
        private http: HttpClient,
        private endpoints: Endpoints,
        public themeService: CustomizerSettingsService,
    ) {}
    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.clientId = params.get('id') || '';
            if (this.clientId) {
                this.fetchClientDetails(this.clientId);
            }
        });
    }
    fetchClientDetails(clientId: string) {
        const terrain_url: string = `${this.endpoints.rapport_endpoint}/${clientId}/clients`;
        console.log("URL utilisée:", terrain_url);
    
        this.http.get<any[]>(terrain_url).subscribe({
            next: (response: any[]) => {
                this.sampleList = response;
                console.log("Clients liés au rapport :", response);
            },
            error: (error) => {
                console.error("Erreur lors de la récupération des clients :", error);
            }
        });
    }
    

}
